const listTableDetailUjian = (data) =>
  data.map((val) => ({
    ...val,
    id: val.id,
    name: val.qbank_detail ? val.qbank_detail.name : '-',
    question: val.qbank_detail ? val.qbank_detail.question : '-',
    name_question: val.qbank_detail ? val.qbank_detail.name : '-',
    point_question: val.qbank_detail ? val.qbank_detail.name : '-',
    explanation_question: val.qbank_detail ? val.qbank_detail.explanation : '-',
    attachment: val.qbank_detail ? val.qbank_detail.attachment : null,
    selected: val.qbank_question_type,
    point: val.qbank_point,
  }));

const listTableDetailParticipant = (data) =>
  data.map((val) => ({
    ...val,
    name: val.user_name || '-',
    weight: '-',
    id: val.user_id,
  }));

const paginatior = (raw, common) => {
  const temp = { ...common };

  if (raw) {
    temp.current_page = raw.page;
    temp.per_page = raw.limit;
    temp.last_page = raw.max_page;
    temp.total = raw.total_item;

    return temp;
  }

  return common;
};

/**
 * BNS-3167: normalize the raw exam question response (getQuestionUjianByGuru)
 * into the exam-detail question entries the create flow hydrates.
 *
 * Every qbank identifier the create payload needs is kept at the top level,
 * and the render-safe preview content (question / answer_options / attachment
 * / explanation) is carried over from qbank_detail so the duplicate-mode
 * Preview (buildDuplicatePreviewQuiz -> ModalPreview / RenderQuestions) shows
 * the real source question and answer text instead of empty placeholders.
 * Missing content falls back to render-safe empty values.
 *
 * These content fields NEVER reach addUjian/addUjianBulk: buildExamPayload
 * remaps every `questions` entry down to the five qbank identifiers and omits
 * prevQuiz outright, so the preview content is display-only.
 */
const normalizeDataQuestion = (data) =>
  data.map((val, idx) => {
    const detail = val && typeof val === 'object' ? val.qbank_detail : null;
    const quizDetail = detail && typeof detail === 'object' ? detail : null;

    return {
      id: `${val.qbank_quiz_id}${idx}`,
      name: quizDetail ? quizDetail.quiz_name : '-',
      qbank_quiz_id: val.qbank_quiz_id,
      qbank_question_id: val.qbank_question_id,
      qbank_group_id: val.qbank_group_id,
      qbank_point: val.qbank_point,
      qbank_question_type: val.qbank_question_type,
      // render-safe preview content preserved from the raw question response
      // (duplicate-mode Preview only — stripped by buildExamPayload)
      question: quizDetail && quizDetail.question != null ? quizDetail.question : '',
      answer_options: quizDetail && Array.isArray(quizDetail.answer_options) ? quizDetail.answer_options : [],
      attachment: quizDetail && quizDetail.attachment != null ? quizDetail.attachment : null,
      explanation: quizDetail && quizDetail.explanation != null ? quizDetail.explanation : '',
    };
  });

export { listTableDetailUjian, listTableDetailParticipant, paginatior, normalizeDataQuestion };
